
const activeComponentsReducer = (state ={},{type,payload}) => {  
  switch(type){
      case "INITIALIZE_ACTIVE_COMPONENTS":
          return Object.assign({}, payload)
      case "CHANGE_MAIN_COMPONENT":
          return Object.assign({},{...state, main :payload}); 
      case "CHANGE_HEADER_COMPONENT":
          return Object.assign({},{...state, header:payload}) 
      case "CHANGE_FOOTER_COMPONENT":
          return Object.assign({},{...state, footer:payload})                     
      default:
      return state;
  }  }
export default activeComponentsReducer;